import { Link } from "react-router-dom";

const MENU = [
  { label: "Home", to: "/" },
  { label: "Work", to: "/#work" },
  { label: "About", to: "/about" },
  { label: "Founder", to: "/#founder" },
  { label: "Services", to: "/#services" },
  { label: "Contact", to: "/#contact" },
  { label: "Booking", to: "/connect" },
];

function Col({ title, children, testid }) {
  return (
    <div data-testid={testid}>
      <div className="font-mono uppercase text-[11px] tracking-[0.12em] text-muted2 mb-5">{title}</div>
      <ul className="space-y-2 font-serif text-[15px]">{children}</ul>
    </div>
  );
}

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="bg-bg text-black border-t border-[#E5E5E5]">
      <div className="px-4 md:px-6 pt-16 md:pt-24 pb-10">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-10 md:gap-6">
          <Col title="[ Menu ]" testid="footer-menu">
            {MENU.map((m) => (
              <li key={m.label}>
                <Link to={m.to} data-testid={`footer-link-${m.label.toLowerCase()}`} className="hover:underline underline-offset-4">{m.label}</Link>
              </li>
            ))}
          </Col>

          <Col title="[ Social ]" testid="footer-social">
            <li><a href="https://instagram.com/qissastudio.co" target="_blank" rel="noreferrer" className="hover:underline underline-offset-4">Instagram</a></li>
            <li><a href="https://linkedin.com/company/qissa-studio" target="_blank" rel="noreferrer" className="hover:underline underline-offset-4">LinkedIn</a></li>
          </Col>

          <Col title="[ Contact ]" testid="footer-contact">
            <li><a href="mailto:info@qissastudio.co" className="hover:underline underline-offset-4">info@qissastudio.co</a></li>
            <li><a href="tel:+917042532497" className="hover:underline underline-offset-4">+91 70425 32497</a></li>
          </Col>

          <Col title="[ Studio ]" testid="footer-studio">
            <li>New Delhi, India</li>
            <li className="text-muted2">& everywhere</li>
          </Col>
        </div>

        <div className="mt-16 md:mt-24 flex items-center justify-between font-mono uppercase text-[11px] tracking-[0.12em] text-muted2">
          <span>QISSA &copy; 2026</span>
          <span>All rights reserved</span>
        </div>
      </div>

      {/* full wordmark, sitting on the bottom edge */}
      <div className="px-4 md:px-6 pb-4 md:pb-6 select-none" aria-hidden>
        <div className="font-display uppercase font-[900] text-black leading-[0.82] tracking-[-0.03em] text-center whitespace-nowrap" style={{ fontSize: "min(31vw, 34vh)" }}>QISSA</div>
      </div>
    </footer>
  );
}
